import React, { useState, useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate , useOutletContext} from 'react-router-dom';
//api
import { createList } from 'api/lists';
//components
import Title from 'components/backoffice/texts/title';
import ListForm from 'components/backoffice/forms/listForm';

const CreateList = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()

  const list = {
    nombre: '',
    tipo: '',
    contenido: '',
    location_web: '',
    estado: false,
    products: []
  };

  useEffect(() => {
    setTitle(t('createlist'))
    return () => {
      setTitle('');
    };
  },[setTitle])

  const onSubmit = useCallback(
    async (values) => {
      setLoading(true)
      try {
        const payload = {
          nombre: values.nombre,
          tipo: values.tipo,
          contenido: values.contenido,
          estado: values.estado,
          location_web: values.location_web,
          producto_ids: values.products.map((item) => item.id),
        };
        const { status } = await createList(payload);
        if (status === 201) {
          toast.success(t('creadocorrectamente'));
          navigate('/intranet/lists', {replace: true});
        } else {
          toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
        }
      } catch (error) {
        console.error('Error en onCreate:', error);
      }
      setLoading(false)
    }, []);

  return (
    <div>
      <Title text={t('createlist')} />
      <ListForm  
        loading={loading} 
        isEditing={false} 
        onSubmitForm={onSubmit} 
        defaultValues={list}
      />
    </div>
  );
};

export default CreateList;
